module.exports = __webpack_public_path__ + "img/symbol-roman-tl-right.d52871b2.png";